export default __webpack_public_path__ + "static/media/dkny.abadc8df.png";